import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-main)' }}>
      <section style={{ padding: '4rem 1.2rem 3rem', background: 'var(--gradient-hero)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <Link to="/" className="body-small" style={{ textDecoration: 'none', color: 'var(--text-secondary)', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '2rem' }}>
            <ArrowLeft size={16} /> Retour à l'accueil
          </Link>
          <h1 className="heading-hero" style={{ marginBottom: '1rem' }}>Mentions Légales</h1>
        </div>
      </section>

      <section style={{ padding: '3rem 1.2rem' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>1. Éditeur du site</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Le site <strong>VAE Accompagnement</strong> est édité par :<br />
              <strong>APDR de la VAE</strong><br />
              SIREN : 833 761 133<br />
              Email : <a href="mailto:apdr.vae@gmail.com">apdr.vae@gmail.com</a><br />
              Téléphone : 06 88 39 96 24<br />
              Responsable de la publication : Rose
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>2. Hébergement</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Ce site est hébergé par :<br />
              <strong>Emergent Labs</strong><br />
              Site web : <a href="https://www.emergentagent.com" target="_blank" rel="noopener noreferrer">www.emergentagent.com</a>
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>3. Propriété intellectuelle</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              L'ensemble des contenus présents sur ce site (textes, images, vidéos, supports pédagogiques, quiz, présentations) est protégé par le droit d'auteur. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site est interdite sans l'autorisation écrite préalable de l'éditeur.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>4. Protection des données personnelles</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.<br /><br />
              Les données collectées sur ce site (nom, prénom, email, téléphone) sont utilisées uniquement dans le cadre de l'accompagnement VAE et ne sont en aucun cas cédées ou vendues à des tiers.<br /><br />
              Pour exercer vos droits, contactez-nous à : <a href="mailto:apdr.vae@gmail.com">apdr.vae@gmail.com</a>
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>5. Cookies</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Ce site utilise des cookies techniques nécessaires au bon fonctionnement de la plateforme (authentification, session utilisateur). Aucun cookie publicitaire ou de traçage n'est utilisé.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>6. Conditions de vente</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Les formations et accompagnements proposés sur ce site sont des prestations de service à caractère éducatif. Les tarifs sont indiqués en euros TTC. Le paiement s'effectue en ligne via la plateforme sécurisée Stripe. Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux contenus numériques fournis en ligne dès lors que l'exécution a commencé avec l'accord du consommateur.<br /><br />
              Accès aux formules : 1 an à compter de la date d'achat.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>7. Limitation de responsabilité</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              L'éditeur s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, il ne saurait garantir l'exhaustivité ni l'absence d'erreurs. L'accompagnement VAE vise à maximiser les chances de réussite du candidat mais ne garantit pas l'obtention du diplôme, celle-ci relevant de la décision souveraine du jury.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
